import {BusinessModuleType} from "./business-modules";
import {IModuleFeatures} from "../client-site";

export enum ClientFeatures {
  Payments = 'payments',
  Shop = 'shop',
  LoyaltyProgram = 'loyalty-program',
  Vouchers = 'vouchers',
  Automations = 'automations',
  SendSms = 'send-sms',
  SkinAnalysis = 'skin-analysis',
}

export const moduleFeatures: Record<BusinessModuleType, IModuleFeatures> = {
  [BusinessModuleType.BEAUTY]: {
    defaultFeatures: [
    ],
    optionalFeatures: [
      ClientFeatures.Payments,
      ClientFeatures.Shop,
      ClientFeatures.LoyaltyProgram,
    ]
  },
};

export const moduleNames: Record<BusinessModuleType, string> = {
  [BusinessModuleType.BEAUTY]: 'יופי וטיפוח',
};
